import React from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/SEO"

export default function HtmlSitemap({ data, location }) {
  const allPages = data.allSitePage.nodes
    .map(item => item.path)
    .filter(
      path =>
        path &&
        path !== "/" &&
        !path.includes("/dev-404-page/") &&
        !path.includes("/404") &&
        !path.includes("/offline-plugin-app-shell-fallback/") &&
        !path.includes("/thank-you/") &&
        !path.includes("/success/")
    )
    .sort((a, b) => a.localeCompare(b))

  const mainPages = allPages.filter(
    path =>
      !path.startsWith("/blog/") &&
      !path.startsWith("/category/") &&
      !path.startsWith("/tag/")
  )

  const blogPages = allPages.filter(path => path.startsWith("/blog/"))
  const categoryPages = allPages.filter(path => path.startsWith("/category/"))
  const tagPages = allPages.filter(path => path.startsWith("/tag/"))

  const formatLabel = path => {
    if (path === "/") return "Home"

    return path
      .replace(/^\/|\/$/g, "")
      .split("/")
      .filter(Boolean)
      .pop()
      .replace(/-/g, " ")
      .replace(/\b\w/g, char => char.toUpperCase())
  }

  const renderLinks = pages =>
    pages.map(path => (
      <li key={path}>
        <Link to={path}>{formatLabel(path)}</Link>
      </li>
    ))

  return (
    <div className="page-content">
      <SEO
        location={location}
        title="HTML Sitemap"
        description="Browse all available pages on Urban Care Chiropractic."
      />

      <div className="container">
        <h1>HTML Sitemap</h1>

        {mainPages.length > 0 && (
          <>
            <h2>Main Pages</h2>
            <ul>{renderLinks(mainPages)}</ul>
          </>
        )}

        {blogPages.length > 0 && (
          <>
            <h2>Blog Pages</h2>
            <ul>{renderLinks(blogPages)}</ul>
          </>
        )}

        {categoryPages.length > 0 && (
          <>
            <h2>Category Pages</h2>
            <ul>{renderLinks(categoryPages)}</ul>
          </>
        )}

        {tagPages.length > 0 && (
          <>
            <h2>Tag Pages</h2>
            <ul>{renderLinks(tagPages)}</ul>
          </>
        )}
      </div>
    </div>
  )
}

export const query = graphql`
  query HtmlSitemapPageQuery {
    allSitePage {
      nodes {
        path
      }
    }
  }
`
